import { Component, OnInit, EventEmitter, Output, Input } from "@angular/core";
import { PznService } from "../../services/pzn.service";
import { GenericService } from "../../services/generic.service";
import { applicationConfig } from "../../applicationConfig";
import { AggregationService } from "../../services/aggregation.service";
import { SessionStorageService } from '../../services/web-storage/session-storage.service';
@Component({
  selector: "bottombucket",
  templateUrl: "./bottombucket.component.html",
  styleUrls: ["./bottombucket.component.scss"]
})
export class BottombucketComponent implements OnInit {
  /*   @Output() pznObj = new EventEmitter<any>(); */
  redesign: boolean;
  showBtm: boolean = false;
  pznData: any;
  pznBottomLeft: any;
  linkCTAArray: any;
  pznBottomRight: any;
  contentCTA: any;
  contentPinned: any;
  personalizedContent: any;
  constructor(
    private pznService: PznService,
    private _genericService: GenericService,
    private _aggregationService: AggregationService,
    private _sessionStorageService: SessionStorageService
  ) {}
  ngOnInit() {
    this._genericService.toggleObs$.subscribe((res: any) => {
      this.redesign = res;
      this.showBtm = true;
    });
    this.pznBottomLeft = null;
    this._aggregationService.aggregationDone.subscribe((res: any) => {
      if (res === "aggregationDone") {
        let pznCont = this._sessionStorageService.getItem("userPzn", true);
        this.pznData = pznCont ? pznCont : applicationConfig.fallBackContent;
        this.setBottoms(this.pznData);
      }
    });
    if (window["pznCall"]) {
      this.getPZNContent();
    } else {
      this.prioritizeContent();
    }
  }

  getPZNContent() {
    let sessData = this._sessionStorageService.getItem("userPzn", true);
    let linkCtaData = this._sessionStorageService.getItem("linkCTA", true);

    // Current Workaround - Making PZN call if linkCTA is null
    if (!sessData || linkCtaData === null) {
      this.pznService.getPZNData().subscribe(
        serviceData => {
          if (serviceData.contents && serviceData.contents.length > 0) {
            this.prioritizeContent(serviceData.contents);
          } else {
            this.prioritizeContent();
          }
        },
        error => {
          this.prioritizeContent();
        }
      );
    } else {
      //  this.prioritizeContent(sessData.contents);
      this.pznData = sessData;
      this.setBottoms(this.pznData);
      this.pznService.linkCTAObs.next(linkCtaData);
    }
  }

  setBottoms(obj) {
    let objcontent = obj.contents;
    this.pznBottomRight =
      objcontent && objcontent.length > 4
        ? obj.contents[4]
        : this.pznBottomRight;
    this.pznBottomLeft =
      objcontent && objcontent.length > 3
        ? obj.contents[3]
        : this.pznBottomLeft;
  }

  prioritizeContent(pznContent?: any) {
    this.pznData = { contents: [] };
    this.contentCTA = [];
    this.personalizedContent = [];
    this.contentPinned = [];
    if (pznContent) {
      pznContent.forEach(content => {
        if (/cta/i.test(content["content_type"])) {
          content["articleLink"] = content["ctaLink"]
            ? content["ctaLink"]
            : content["articleLink"];
          this.contentCTA.push(content);
        } else if (/pinned/i.test(content["pinned"])) {
          this.contentPinned.push(content);
        } else {
          this.personalizedContent.push(content);
        }
      });
      this.linkCTAArray = this.contentCTA.filter(obj =>
        /link by prudential/i.test(obj["solution"])
      );
      this._sessionStorageService.setItem("linkCTA", this.linkCTAArray, true);
      this.pznService.linkCTAObs.next(this.linkCTAArray);

      this.contentCTA = this.contentCTA.filter(
        obj => !/link by prudential/i.test(obj["solution"])
      );
      /* this.contentCTA.sort(function (a, b) { return (a.pinned > b.pinned) ? 1 : ((b.pinned > a.pinned) ? -1 : 0); }); */
    }

    if (!this.linkCTAArray) {
      this.pznService.linkCTAObs.next([]);
    }

    for (let i = 0; i < 5; i++) {
      this.pznData.contents[i] =
        this.personalizedContent[i] ||
        applicationConfig.fallBackContent.contents[i];
    }

    this.pznData.contents[4] =
      this.contentCTA.length > 1
        ? this.contentCTA.pop()
        : this.contentPinned.pop() || this.pznData.contents[4];
    this.pznData.contents[3] =
      this.contentCTA.pop() ||
      this.contentPinned.pop() ||
      this.pznData.contents[3];

    this._sessionStorageService.setItem("userPzn", this.pznData, true);
    this.setBottoms(this.pznData);
  }
}
